import { createNamedContext } from '@core/createNamedContext'

export interface GlobalClientConfigContextValue {
  bankingUrl: string
  registrationUrl: string
}

export const GlobalClientConfigContext =
  createNamedContext<GlobalClientConfigContextValue>(
    'GlobalClientConfigContext',
    {
      bankingUrl: '',
      registrationUrl: '',
    }
  )
